import React from "react";
const Embed = (props) => {
  const ref = React.useRef();
  return (
    <div className="container-fluid wrapper_fluid">
      <div className="row">
        <div className="col-md-12 col-xs-12">
          <iframe
            src={props.information.urlPage}
            title={props.information.urlName}
            ref={ref}
            scrolling="no"
            frameBorder="0"
            style={{
              width: "100%",
              height: "95vw",
              overflow: "auto",
            }}
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default Embed;
